<template>
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 0.259277C8.02219 0.259277 6.08879 0.856627 4.4443 1.97579C2.79981 3.09495 1.51809 4.68565 0.761209 6.54675C0.00433284 8.40785 -0.193701 10.4558 0.192152 12.4315C0.578004 14.4073 1.53041 16.222 2.92894 17.6465C4.32746 19.0709 6.10929 20.041 8.0491 20.434C9.98891 20.8269 11.9996 20.6252 13.8268 19.8543C15.6541 19.0834 17.2159 17.778 18.3147 16.1031C19.4135 14.4281 20 12.4589 20 10.4445C20 7.74318 18.9464 5.15257 17.0711 3.24247C15.1957 1.33238 12.6522 0.259277 10 0.259277ZM10 19.1742C8.30482 19.1742 6.6477 18.6622 5.23821 17.703C3.82872 16.7437 2.73015 15.3803 2.08143 13.7852C1.43272 12.19 1.26298 10.4348 1.59369 8.74138C1.92441 7.04798 2.74072 5.49249 3.93939 4.27162C5.13807 3.05075 6.66528 2.21932 8.32789 1.88248C9.9905 1.54564 11.7138 1.71851 13.28 2.37924C14.8461 3.03997 16.1847 4.15891 17.1265 5.5945C18.0683 7.0301 18.571 8.71789 18.571 10.4445C18.571 12.7597 17.668 14.9802 16.0606 16.6173C14.4532 18.2544 12.2732 19.1742 10 19.1742Z"
            :fill="color || '#AAAAAA'"
        />
    </svg>
</template>
<script>
export default {
    name: "IconPicker",
    props: ["color"],
};
</script>


// WEBPACK FOOTER //
// src/components/V2/svg/components/IconPicker.vue